(function () {
  if (window.__zuitableStandardPdpPerformance) return;
  window.__zuitableStandardPdpPerformance = true;

  var observer = null;
  var observedNode = null;
  var timer = null;
  var syncing = false;
  var lazyVideoObserver = null;

  function getSize() {
    var selectors = Array.from(document.querySelectorAll('.shopify-section--main-product .product-form__option-selector'));
    var sizeSelector = selectors.find(function (selector) {
      var name = selector.querySelector('.product-form__option-name');
      var label = (name ? name.textContent : '').toLowerCase();
      return label.indexOf('größe') !== -1 || label.indexOf('groesse') !== -1 || label.indexOf('size') !== -1;
    });
    if (!sizeSelector) return '';
    var value = sizeSelector.querySelector('.product-form__option-value, .select__selected-value');
    return value ? (value.textContent || '').trim() : '';
  }

  function optionMatchesSize(optionText, wanted) {
    var cleanOption = String(optionText || '').replace(/–.*$/, '').trim().toLowerCase();
    var cleanWanted = String(wanted || '').trim().toLowerCase();
    if (!cleanWanted) return false;
    if (cleanOption === cleanWanted) return true;
    var escaped = cleanWanted.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return new RegExp('(^|[^a-z0-9])' + escaped + '([^a-z0-9]|$)', 'i').test(cleanOption);
  }

  function syncMatchingSize() {
    var wanted = getSize();
    if (!wanted) return;
    document.querySelectorAll('.zuit-suit-cross-sell--single .zuit-suit-cross-sell__select').forEach(function (select) {
      var match = Array.from(select.options).find(function (option) {
        return !option.disabled && optionMatchesSize(option.textContent, wanted);
      });
      if (match && select.value !== match.value) {
        select.value = match.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  function enhanceSizeFinderCopy() {
    var inline = document.querySelector('.zuit-size-finder-inline');
    if (!inline) return;
    var title = inline.querySelector('.zsf-dialog h2');
    if (title && title.textContent !== 'Finde deine Größe') title.textContent = 'Finde deine Größe';
    var hint = inline.querySelector('.zsf-hint');
    var text = 'Die Empfehlung ist eine Orientierung auf Basis durchschnittlicher Proportionen. Du kannst die ausgewählte Größe danach jederzeit ändern.';
    if (hint && hint.textContent !== text) hint.textContent = text;
  }

  function applyProductContext() {
    var context = document.querySelector('[data-zuit-standard-context]');
    var nonSuiting = context && context.getAttribute('data-suiting') === 'false';
    document.documentElement.classList.toggle('zuit-standard-non-suiting', !!nonSuiting);
    if (!nonSuiting) return;

    document.querySelectorAll('.zuit-size-finder-inline, .shopify-section--main-product .zpd-usps, .z-vsplit').forEach(function (node) {
      node.style.display = 'none';
    });

    var details = document.querySelector('.zuit-product-details-section');
    if (!details || details.dataset.zuitNonSuitingCleaned === 'true') return;
    details.dataset.zuitNonSuitingCleaned = 'true';

    details.querySelectorAll('.zuit-product-details__content').forEach(function (content) {
      if ((content.textContent || '').indexOf('Hochwertiger Jersey-Stoff mit angenehmem Tragegefühl') !== -1) {
        content.innerHTML = '<p>Die genaue Materialzusammensetzung und die Pflegehinweise findest du am Produktetikett. Bitte beachte die dort angegebenen Hinweise, damit dein Produkt lange in Form bleibt.</p>';
      }
    });
    details.querySelectorAll('.zuit-product-details__box').forEach(function (box) {
      var title = box.querySelector('strong');
      var label = (title ? title.textContent : '').trim().toLowerCase();
      if (label === 'separat kombinierbar' || label === 'größenhilfe' || label === 'groessenhilfe') box.remove();
    });
  }

  function moveProductDetails() {
    var details = document.querySelector('.zuit-product-details-section');
    if (!details) return;
    var target = document.getElementById('zuit-matching-suit') || document.getElementById('zuit-matching-pants') || document.getElementById('zuit-matching-jacket');
    if (!target) return;
    var section = target.closest('.shopify-section');
    if (section && section.nextElementSibling !== details) section.insertAdjacentElement('afterend', details);
    if (window.matchMedia('(max-width: 749px)').matches && details.dataset.zuitCollapsed !== 'true') {
      details.querySelectorAll('details[open]').forEach(function (item) { item.removeAttribute('open'); });
      details.dataset.zuitCollapsed = 'true';
    }
  }

  function hideEmptyMetaAside() {
    document.querySelectorAll('.shopify-section--main-product .product-meta__aside').forEach(function (aside) {
      if (!aside.querySelector('.product-meta__help')) aside.style.display = 'none';
    });
  }

  function updateSticky() {
    var info = document.querySelector('.product-sticky-form .product-sticky-form__bottom-info');
    if (!info) return;
    var size = getSize();
    var line = info.querySelector('.zuit-sticky-size');
    if (!line) {
      line = document.createElement('span');
      line.className = 'zuit-sticky-size';
      info.appendChild(line);
    }
    var next = size ? 'Größe ' + size : '';
    if (line.textContent !== next) line.textContent = next;
    line.hidden = !size;
  }

  function enhanceCartFeedback() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    document.querySelectorAll('.zuit-suit-cross-sell__status[data-state="success"]').forEach(function (status) {
      if (!status.querySelector('a')) status.innerHTML = '✓ In den Warenkorb gelegt. <a href="' + root + 'cart">Warenkorb ansehen</a>';
    });
  }

  function loadStoryVideo(video) {
    if (!video || video.dataset.zuitLoaded === 'true') return;
    var src = video.getAttribute('data-src');
    if (!src) return;
    video.dataset.zuitLoaded = 'true';
    video.src = src;
    video.removeAttribute('data-src');
    video.load();
    var play = video.play();
    if (play && typeof play.catch === 'function') play.catch(function () {});
  }

  function initLazyVideo() {
    var videos = document.querySelectorAll('video.zuit-lazy-story-video[data-src]');
    if (!videos.length) return;
    if (!('IntersectionObserver' in window)) {
      videos.forEach(loadStoryVideo);
      return;
    }
    if (!lazyVideoObserver) {
      lazyVideoObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          loadStoryVideo(entry.target);
          lazyVideoObserver.unobserve(entry.target);
        });
      }, { rootMargin: '500px 0px' });
    }
    videos.forEach(function (video) {
      if (video.dataset.zuitObserved === 'true') return;
      video.dataset.zuitObserved = 'true';
      lazyVideoObserver.observe(video);
    });
  }

  function observe() {
    if (!('MutationObserver' in window)) return;
    var node = document.querySelector('product-rerender[id^="product-info-"]');
    if (!node) return;
    if (node !== observedNode) {
      if (observer) observer.disconnect();
      observedNode = node;
      observer = new MutationObserver(schedule);
    }
    observer.disconnect();
    observer.observe(node, { childList: true, subtree: true });
  }

  function sync() {
    if (syncing) return;
    syncing = true;
    if (observer) observer.disconnect();
    try {
      enhanceSizeFinderCopy();
      syncMatchingSize();
      applyProductContext();
      moveProductDetails();
      hideEmptyMetaAside();
      updateSticky();
      enhanceCartFeedback();
      initLazyVideo();
    } finally {
      syncing = false;
      observe();
    }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(sync, 140);
  }

  document.addEventListener('change', function (event) {
    if (event.target.closest('.shopify-section--main-product .product-form')) setTimeout(sync, 0);
  });

  document.addEventListener('click', function (event) {
    var link = event.target.closest('.zuit-product-info-matching-link__button, .zuit-scroll-to-matching__button');
    if (!link) return;
    var href = link.getAttribute('href');
    if (!href || href.charAt(0) !== '#') return;
    var target = document.querySelector(href);
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('.zuit-suit-cross-sell__form');
    if (!form || form.dataset.zuitSubmitting === 'true') return;
    event.preventDefault();
    form.dataset.zuitSubmitting = 'true';
    var button = form.querySelector('.zuit-suit-cross-sell__add');
    var status = form.querySelector('.zuit-suit-cross-sell__status');
    var previous = button ? button.textContent : '';
    if (button) { button.disabled = true; button.textContent = 'Wird hinzugefügt …'; }
    if (status) { status.textContent = ''; status.dataset.state = ''; }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw new Error(data.description || data.message || 'Das Produkt konnte nicht hinzugefügt werden.');
        return data;
      });
    }).then(function () {
      if (status) { status.textContent = '✓ In den Warenkorb gelegt.'; status.dataset.state = 'success'; }
      enhanceCartFeedback();
      if (button) button.textContent = 'Hinzugefügt ✓';
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      setTimeout(function () { if (button) { button.disabled = false; button.textContent = previous || 'Hinzufügen'; } }, 1600);
    }).catch(function (error) {
      if (status) { status.textContent = error.message || 'Das Produkt konnte nicht hinzugefügt werden.'; status.dataset.state = 'error'; }
      if (button) { button.disabled = false; button.textContent = previous || 'Hinzufügen'; }
    }).finally(function () {
      form.dataset.zuitSubmitting = 'false';
    });
  });

  document.addEventListener('cart:updated', function () { setTimeout(function () { enhanceCartFeedback(); updateSticky(); }, 0); });
  document.addEventListener('shopify:section:load', schedule);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync, { once: true });
  else sync();
})();
